import React from 'react';
import PropTypes from 'prop-types';
import { HashLink } from 'react-router-hash-link';

import DesktopHeader from '../../DesktopHeader';
import StartScreenParallaxPic from './StartScreenParallaxPic';

const StartScreen = props => {
  return (
    <section className="start-screen" id="start-screen-container-id">
      <DesktopHeader openSidebar={props.openSidebar} isPrimary />
      <div className="start-screen-footer">
        <HashLink to="/#info-screen-container-id" className="start-screen-footer-link" smooth>
          ↓
        </HashLink>
      </div>
      <div className="tutorium-container start-screen-body">
        <div>
          <p className="landing-caption-light">Educational platform for IT companies and individual developers</p>
          <p className="landing-text-light mt-20px">
            We provide practical programming courses. Improve your programming skills and be successful!
          </p>
          <p className="mt-40px">
            <HashLink to="/#request-screen-container-id" className="button" smooth>
              Send request
            </HashLink>
          </p>
        </div>
        <StartScreenParallaxPic />
      </div>
    </section>
  );
};

StartScreen.propTypes = {
  openSidebar: PropTypes.func.isRequired,
};

export default StartScreen;
